// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var BatchID = function (x) {
    return x;
};
var tsBridgeBatchID = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("BatchID")("__brandBatchID"));
    }
};
var writeBatchID = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showBatchID = Data_Show.showString;
var readBatchID = Simple_JSON.readString;
var ordBatchID = Data_Ord.ordString;
var newtypeBatchID = {
    Coercible0: function () {
        return undefined;
    }
};
var makeBatchID = BatchID;
var eqBatchID = Data_Eq.eqString;
export {
    BatchID,
    makeBatchID,
    unwrap,
    newtypeBatchID,
    eqBatchID,
    ordBatchID,
    showBatchID,
    readBatchID,
    writeBatchID,
    tsBridgeBatchID
};
//# sourceMappingURL=index.js.map
